<div [ngClass]="{'import-block__completed': !isActive() && stepState == ImportStepState.Completed, 'import-block__collapsed': !isActive() && stepState == ImportStepState.Available, 'import-block__not-available': stepState <= ImportStepState.NotAvailableYet, 'loading': dataLoading }"
    class="import-block">
    <div class="d-flex align-items-center">
        <div class="number-circle"><span [ngClass]="{'subtitle-2': stepState !== ImportStepState.Completed, 'material-icons-outlined': (stepState === ImportStepState.Completed && !isActive())}">{{
                (stepState === ImportStepState.Completed && !isActive()) ? 'check' : '6' }}</span></div>
        <h4>Aggregation</h4>
    </div>
    <ng-container *ngIf="isActive()">
        <div class="body-1 mb-8">Confirm the logic to aggregate the metrics when analysing clusters</div>
        <div class="table-container no-border small-cell">
            <!-- Header row -->
            <div class="row header">
                <div class="cell">
                    <div class="subtitle-2">Component</div>
                </div>
                <div class="cell">
                    <div class="subtitle-2">Aggregation Logic</div>
                </div>
                <div class="cell">
                    <div class="subtitle-2">Weighted By</div>
                </div>
            </div>

            <!-- Data rows -->
            <div class="row row-grey">
                <div class="cell">
                    <span class="body-2">{{outcomeName}}</span>
                </div>
                <div class="cell"></div>
                <div class="cell"></div>
            </div>
            <div class="row" *ngFor="let formComp of formComps; let i = index">
                <div class="cell align-self-center">
                    <span class="body-2">{{ formComp.name }}</span>
                </div>

                <div class="cell">
                    <div class="radio-group side-by-side">
                        <label class="radio-button">
                            <input type="radio" [name]="'options' + i" [value]="UIAggregationType.sum" [(ngModel)]="formComp.aggregationMethod.type"
                                (ngModelChange)="onAggregationMethodChange(formComp, $event)">
                            <span class="subtitle-2">Sum</span>
                        </label>
                        <label class="radio-button">
                            <input type="radio" [name]="'options' + i" [value]="UIAggregationType.averageSomehow" [(ngModel)]="formComp.aggregationMethod.type"
                                (ngModelChange)="onAggregationMethodChange(formComp, $event)">
                            <span class="subtitle-2">Average</span>
                        </label>
                    </div>
                </div>

                <div class="cell">
                    <mat-form-field appearance="fill">
                        <mat-select [(value)]="formComp.aggregationMethod.columnIndex" (selectionChange)="onColumnToAvgChange(formComp.aggregationMethod)">
                            <mat-option [value]="'None'">None</mat-option>
                            <mat-option *ngFor="let column of (numericColumns | filterByPropNot: 'index': formComp.columnIx)" [value]="column.index">
                                {{ column.name }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
        </div>
        <div>
            <button (click)="save()" [ngClass]="{'loading-small':loading, 'btn':true}">Continue</button>
        </div>
    </ng-container>
    <ng-container *ngIf="!isActive() && stepState == ImportStepState.Completed">
        <div class="d-flex">
            <div class="info-block">
                <span class="body-1">Logic</span>
                <span class="body-1 text-900">{{summary}}</span>
            </div>
        </div>
        <div>
            <button (click)="editClick()" [ngClass]="{'loading-small':loading}" class="btn btn-secondary btn-icon btn-edit"><span class="material-icons-outlined">edit</span></button>
        </div>
    </ng-container>
</div>
